export enum CheckboxState {
  Partial = 'selected-partial',
  All = 'selected-all',
  None = 'selected-none',
}
